import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { devError } from "../lib/logger";
import { getPendingReferralCode, clearPendingReferralCode } from "../lib/referral";

const AuthCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/", { replace: true }); return; }
    const session_id = match[1];
    const referral_code = getPendingReferralCode();
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {
          session_id,
          ...(referral_code ? { referral_code } : {}),
        });
        clearPendingReferralCode();
        setUser(data.user);
        window.history.replaceState({}, "", "/ask");
        nav("/ask", { replace: true, state: { user: data.user } });
      } catch (err) {
        devError("Session exchange failed", err);
        nav("/", { replace: true });
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <svg className="glyph-loader mx-auto mb-6" width="60" height="60" viewBox="0 0 60 60" fill="none">
          <circle cx="30" cy="30" r="26" stroke="#D4AF37" strokeWidth="1" strokeDasharray="3 5" />
          <circle cx="30" cy="30" r="3" fill="#D4AF37" />
        </svg>
        <p className="text-sm uppercase tracking-[0.3em] text-neutral-400">Opening the gate…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
